// subforms/index.ts
import { useTranslation } from 'react-i18next';
import {
  ExtractExportStrategyType,
  SubformRecord,
} from '@/modules/admin/audits/components/submodules/types';
import { DueInvoicesExportSubModule } from '@/modules/admin/audits/components/submodules/AuditsExportsDueINvoicesExportSubmodule';
import { AuditsExportsProvisionExportSubmodule } from '@/modules/admin/audits/components/submodules/AuditsExportsProvisionExportSubmodule';
import { AuditsExportsEmploymentContractsExportSubmodule } from '@/modules/admin/audits/components/submodules/AuditsExportsEmploymentContractsExportSubmodule';
import { AuditsExportsMarginsExportSubmodule } from '@/modules/admin/audits/components/submodules/AuditsExportsMarginsExportSubmodule';
import { AuditsExportsMonthlyTurnoverExportSubmodule } from '@/modules/admin/audits/components/submodules/AuditsExportsMonthlyTurnoverExportSubmodule';
import { AuditsExportsActiveEmployeesExportSubmodule } from '@/modules/admin/audits/components/submodules/AuditsExportsActiveEmployeesExportSubmodule';
import { AuditsExportsTupCollabsExportSubmodule } from '@/modules/admin/audits/components/submodules/AuditsExportsTupCollabsExportSubmodule';
import { AuditsExportsEmployeesInOutExportSubmodule } from '@/modules/admin/audits/components/submodules/AuditsExportsEmployeesInOutExportSubmodule';
import { AuditsExportsTupDocumentsExportSubmodule } from '@/modules/admin/audits/components/submodules/AuditsExportsTupDocumentsExportSubmodule';
import { AuditsExportsCadrageDendreoExportSubmodule } from '@/modules/admin/audits/components/submodules/AuditsExportsCadrageDendreoExportSubmodule';
import { AuditsExportsPostPayrollAnalysisExportSubmodule } from '@/modules/admin/audits/components/submodules/AuditsExportsPostPayrollAnalysisExportSubmodule';
import { AuditsExportsRemindersExportSubmodule } from '@/modules/admin/audits/components/submodules/AuditsExportsRemindersExportSubmodule';
import { AllInvoiceSubModule } from './AuditsExportAllInvoiceSubmodule';

export const subformModules = [
  // Simply add your subform modules here
  AllInvoiceSubModule,
  DueInvoicesExportSubModule,
  AuditsExportsProvisionExportSubmodule,
  AuditsExportsEmploymentContractsExportSubmodule,
  AuditsExportsMarginsExportSubmodule,
  AuditsExportsMonthlyTurnoverExportSubmodule,
  AuditsExportsActiveEmployeesExportSubmodule,
  AuditsExportsTupCollabsExportSubmodule,
  AuditsExportsEmployeesInOutExportSubmodule,
  AuditsExportsTupDocumentsExportSubmodule,
  AuditsExportsCadrageDendreoExportSubmodule,
  AuditsExportsPostPayrollAnalysisExportSubmodule,
  AuditsExportsRemindersExportSubmodule,
] as const;

export type SubformModules = typeof subformModules;

export function useSubformOptions() {
  const { t } = useTranslation();
  return subformModules
    .map((module) => {
      const key = module.jsonApiType.split('-').pop();
      return {
        value: module.jsonApiType,
        label:
          (module as unknown as { label: string }).label ||
          t(`activerecord.models.audits/exports/${key}`, {
            ns: 'rails',
          }),
      };
    })
    .sort((a, b) => a.label.localeCompare(b.label));
}

export const getSubModuleByJsonApiType = (jsonApiType: string | null) =>
  subformModules.find((module) => module.jsonApiType === jsonApiType);

export type ExportStrategyType =
  | { key: null | string; params: object }
  | ExtractExportStrategyType<SubformModules[number]>;

export function createExportStrategy(data: ExportStrategyType): SubformRecord {
  const module = getSubModuleByJsonApiType(data.key);
  if (!data.key || !module) {
    throw new Error(`Subform module not found for key ${data.key}`);
  }

  return module.createExportStrategy(data.params as any); // eslint-disable-line @typescript-eslint/no-explicit-any
}
